import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateCouplesPackUsers } from "../services/update-couples-pack-users";

export function useUpdateCouplesPackUsers() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      user_ids,
      couples_pack_usage_identifier,
    }: {
      user_ids: string[];
      couples_pack_usage_identifier: string;
    }) => updateCouplesPackUsers({user_ids, couples_pack_usage_identifier}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["couples-packs"], exact: false });
      toast({
        title: "Success",
        description: "Usage Identifier updated successfully",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description:
          error?.message || "Failed to update couples pack professional",
        variant: "destructive",
      });
    },
  });
}
